import { forwardRef, useRef } from 'react';
import { ButtonSize, ButtonVariant } from '../../utils/buttonStyles.js';
import { getButtonIconComponentStyles, getIconStyles } from './ButtonIconStyles.js';
import { useMergeRefs } from 'use-callback-ref';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { useHoverableTooltip } from '../Tooltip/useTooltip.js';
import { Button } from '../Button/Button.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { Icon } from '../Icon/Icon.js';

const ButtonIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    icon,
    children,
    ariaDescribedby,
    placement,
    size = ButtonSize.MEDIUM,
    variant = ButtonVariant.FILLED,
    isInactive = false,
    disabled = false,
    ...rest
  } = _ref;
  const newRef = useRef(null);
  const buttonRef = useMergeRefs([newRef, ref]);
  const {
    opened
  } = useHoverableTooltip(buttonRef);
  return jsxs(Fragment, {
    children: [jsx(Button, {
      ref: buttonRef,
      "aria-describedby": ariaDescribedby,
      css: getButtonIconComponentStyles(size, variant, isInactive, disabled),
      size: size,
      variant: variant,
      isInactive: isInactive,
      disabled: disabled,
      ...rest,
      children: jsx(Icon, {
        name: icon,
        css: getIconStyles(size)
      })
    }), children && jsx(Tooltip, {
      placement: placement,
      reference: buttonRef.current,
      id: ariaDescribedby !== null && ariaDescribedby !== void 0 ? ariaDescribedby : '',
      isOpen: opened && !disabled,
      children: children
    })]
  });
});
ButtonIcon.displayName = 'ButtonIcon';

export { ButtonIcon };
//# sourceMappingURL=ButtonIcon.js.map
